export default "__VITE_ASSET__OU18QQvz__";